import { classNames } from "@/react/helpers/twMergeWithCN";
import { useSmOrMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";
import { useHelpWidgetContext } from "../../context/HelpWidgetContext";

interface HelpWidgetLayoutProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export const HelpWidgetLayout = ({
  children,
  className,
  id,
}: HelpWidgetLayoutProps) => {
  const { isExpanded } = useHelpWidgetContext();
  const isMobile = useSmOrMdScreenMediaQuery();

  return (
    <div
      id={id}
      className={classNames(className || "", {
        "w-[736px]": isExpanded,
        "w-[400px]": !isExpanded,
        "w-full": isMobile,
      })}
    >
      {children}
    </div>
  );
};
